import { GET_CATEGORIES_REQUEST, GET_CATEGORIES_SUCCESS, GET_CATEGORIES_FAILURE } from '../actions/getCategories';

const initialState = {
  cat_loading: false,
  cat_error: null,
  cat_data: null,
};

export default function getCategoriesReducer(state = initialState, action) {
  switch (action.type) {
    case GET_CATEGORIES_REQUEST:
      return { ...state, cat_loading: true, cat_error: null };
    case GET_CATEGORIES_SUCCESS:
      return { ...state, cat_loading: false, cat_data: action.payload };
    case GET_CATEGORIES_FAILURE:
      return { ...state, cat_loading: false, cat_error: action.payload };
    default:
      return state;
  }
}